import script from "./Headline.vue?vue&type=script&lang=ts&setup=true"
export * from "./Headline.vue?vue&type=script&lang=ts&setup=true"

import "./Headline.vue?vue&type=style&index=0&id=3f2cfeee&lang=scss"

const __exports__ = script;

export default __exports__